<template>
  <header ref="header" class="header">
    <nav ref="navbar" class="navbar" :class="{ sticky: isSticky, small: isSmall, top: isTop }" v-resize="updateHeader">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <img class="navbar-logo" src="~images/logo.png" alt="GAMMA-PRESS">
        </router-link>

        <div class="navbar-burger burger" @click='burgerIsActive = !burgerIsActive' :class="{ 'is-active': burgerIsActive }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" :class="{ 'is-active': burgerIsActive }">
        <ul class="navbar-start">
          <li class="navbar-item" v-for="route in routes">
              <router-link :to="route" class="nav-link">
                  {{ route.title }}
              </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import resize from 'vue-resize-directive'

export default {
  data() {
    return {
      isSticky: true,
      isSmall: false,
      isTop: true,
      burgerIsActive: false
    };
  },
  computed: {
    routes: function() {
      var routes = [];
      for (var i in this.$router.options.routes) {
        if (!this.$router.options.routes.hasOwnProperty(i)) {
          continue;
        }
        var route = this.$router.options.routes[i];
        if (route.hasOwnProperty("title")) {
          routes.push(route);
        }
      }
      return routes;
    }
  },
  methods: {
    updateHeader() {
      var navbarHeight = this.$refs.navbar.getBoundingClientRect().height;
      this.$refs.header.setAttribute("style", "height:" + navbarHeight + "px");
      this.$store.commit('SET_SCROLLTO_OFFSET', navbarHeight);
    }
  },
  mounted() {
    setTimeout(() => {
      this.updateHeader();
    }, 0);
    window.onscroll = (event) => {
      if (this.burgerIsActive && window.scrollY < 6) {
        this.burgerIsActive = !this.burgerIsActive;
      }

      this.isTop = window.scrollY > 0 ? false : true;

      if (window.scrollY > 650) {
        this.isSmall = true;
      } else if (window.scrollY < 550) {
        this.isSmall = false;
      }
    };
  },
  directives: {
    resize
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.navbar {
  padding: 2rem 11vw;
  display: flex;
  align-items: stretch;
  transition: all .35s;
  z-index: 1;
  background: linear-gradient(to top right, rgba($main, 0.97) 35%, darken($main, 5) 100%);
  box-shadow: 0 4px 10px 0 rgba($dark, 0.45);

  @media screen and (max-width: $desktop-medium) {
    padding: 2rem 6vw;
  }

  @media screen and (max-width: $desktop-small) {
    padding: 1.5rem 2vw;
  }

  @media screen and (max-width: $tablet) {
    flex-direction: column;
  }

  @media screen and (max-width: $mobile) {
    padding: 1rem 2vw;
  }
}

.navbar.sticky {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
}

.navbar.top {
  box-shadow: 0 4px 10px 0 rgba($dark, 0.65);
}

.navbar.small {
  padding: 1rem 11vw;

  @media screen and (max-width: $desktop-medium) {
    padding: 1rem 6vw;
  }

  @media screen and (max-width: $desktop-small) {
    padding: 1rem 2vw;
  }

  @media screen and (max-width: $mobile) {
    padding: 1rem 2vw;
  }
}

.navbar-brand {
  @media screen and (max-width: $tablet) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.navbar-brand > .navbar-item {
  padding: 0;
}

.navbar-menu {
  padding-left: 3vw;
  display: flex;
  align-items: center;

  @media screen and (max-width: $tablet) {
    padding-left: 0;
    display: none;

    &.is-active {
      display: flex;
    }
  }
}

.navbar-start {
  display: flex;

  @media screen and (max-width: $tablet) {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
}

.navbar-item img {
  max-height: 15vw;
  width: 8rem;

  @media screen and (max-width: $desktop-medium) {
    width: 7rem;
  }

  @media screen and (max-width: $mobile) {
    width: 6rem;
  }
}

.navbar-menu .navbar-item {
  padding: .3rem 1rem;
}

.nav-link {
  color: $white;
  font-size: $text-plain-desktop;
  text-transform: uppercase;

  @media screen and (max-width: $desktop-medium) {
   font-size: $text-plain-tablet;
  }

  @media screen and (max-width: $mobile) {
   font-size: $text-plain-mobile;
  }

  &:after {
   content: '';
   transform: scale3d(0, 1, 1);
   display: block;
   width: 100%;
   height: 2px;
   background: currentColor;
   transition: transform .35s;
  }

  &:hover:after {
   transform: scale3d(1, 1, 1);
   transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
   transition-duration: .35s;
  }

  &.router-link-active:after {;
   transform: scale3d(1, 1, 1);
   transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
   transition-duration: .35s;
   transition-delay: .35s;
  }
}

.navbar-burger {
  color: $white;
  transform: scale(1.7);
  cursor: pointer;
  display: none;
  height: 3.25rem;
  position: relative;
  width: 3.25rem;
  margin-left: auto;

  @media screen and (max-width: $tablet) {
    display: block;
  }

  & span {
    background-color: currentColor;
    display: block;
    height: 1px;
    left: 50%;
    margin-left: -7px;
    position: absolute;
    top: 50%;
    transition: none 86ms ease-out;
    transition-property: background, left, opacity, transform;
    width: 15px;

    &:nth-child(1) {
      margin-top: -6px;
    }

    &:nth-child(2) {
      margin-top: -1px;
    }

    &:nth-child(3) {
      margin-top: 4px;
    }
  }

  &.is-active span {
    &:nth-child(1) {
      margin-left: -5px;
      transform: rotate(45deg);
      transform-origin: left top;
    }

    &:nth-child(2) {
      opacity: 0;
    }

    &:nth-child(3) {
      margin-left: -5px;
      transform: rotate(-45deg);
      transform-origin: left bottom;
    }

  }
}
</style>



// WEBPACK FOOTER //
// client/components/Header.vue